import CybsTab from '@cybs-ui/components/lib/tab';
import React from 'react';
import { connect } from 'react-redux';
import { putDataInDevCenterDataStore } from '../../../../../app/store';
import { copyStringToClipboard } from '../../../../../libs/common-library';
import AuthenticationCard from '../../../../static/components/authentication-card';
import { getExampleValue } from '../../../reducers/examples-reducer';
import {getRequestBuilderTabIndex} from '../../../reducers/rhs-schema-reducer';
import JsTree from '../../tree/js/js-tree';
import copyButton from '../imgs/copy-button.png';
import CircularProgress from '@material-ui/core/CircularProgress';
import { bodyLevelHandleSelection, enableCopyMessage } from '../js/live-console';
import '../css/live-console.css';
import $ from 'jquery';
/**
 * Request description in live console tab 
 */
var hasBodyParams = false;
var requestTabs = [];
var requestBuilderTabIndex = getRequestBuilderTabIndex(); 

class RequestBuilderTabsInLiveConsole extends React.Component {

    render() {
        requestTabs = [
            {
                label: 'Request Builder',
                children: (
                    <div>
                    <CircularProgress class = "JstreeLoaderIndicator"id = "JstreeLoaderIndicator"/> 
                    <div style={{ display :'none' }} id="requestBuilderJsTreeTab">
                        {
                            this.props.hasBodyParams &&
                            <div>
                                <JsTree />
                                {false && <img class="requestCopyButton" src={copyButton} onClick={() => copyStringToClipboard(getExampleValue(), enableCopyMessage('copySuccessful'))} />}
                            </div>
                        }
                    </div>
                    </div>
                ),
                disabled: !this.props.hasBodyParams
            },
            {
                label: 'Configuration',
                dataTest: 'Configuration',
                children: (
                    <div>
                        <div class="tabInstructions">These changes are reflected in the live console.</div>
                        <div class="configurationAuthenticationCard">
                            <AuthenticationCard src="API" />
                        </div>
                    </div>
                )
            }
        ];
        if (!this.props.hasBodyParams) {
            requestTabs.splice(0, 1);
        }

        if (requestTabs.length <= this.props.requestBuilderTabIndex) {
            putDataInDevCenterDataStore({ type: 'UPDATE_REQUEST_BUILDER_TAB_INDEX', requestBuilderTabIndex: 0 });
        }

        if(this.props.exampleSummary == "No Sample Request Available"){
            $(".configurationAuthenticationCard .authentication-card").css({"maxHeight":"398px"});
        }
        else{
            $(".configurationAuthenticationCard .authentication-card").css({"maxHeight":"433px"});
        }
        return (
            <div id="request-tabs" style={{ width: '100%' }}>
                <CybsTab
                    headingLevel={3}
                    selectedTab={this.props.requestBuilderTabIndex}
                    onSelectTab={(e, index) => bodyLevelHandleSelection(e, index)}
                    dataTest="heading-level-tabs-request-builder"
                    tag="button"
                    // isUnderlined
                    tabs={requestTabs}
                />
            </div>
        );

    }
}
function mapStateToProps(state) {
    hasBodyParams = (state.lhsReducer.hasBodyParams == undefined) ? false : state.lhsReducer.hasBodyParams;
    requestBuilderTabIndex = (state.rhsReducer.requestBuilderTabIndex == undefined) ? 0: state.rhsReducer.requestBuilderTabIndex;

    return {
        hasBodyParams: hasBodyParams,
        requestBuilderTabIndex :requestBuilderTabIndex,
    };

}

export default connect(mapStateToProps)(RequestBuilderTabsInLiveConsole);